



































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import RencanaAskepSvc from "@/services/RencanaAskep";
import ImplementasiAskepSvc from "@/services/ImplementasiAskep";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import ImplementasiObatInline from "@/components/AskepGadar/ImplementasiObatInline.vue";

// one modal writes two records (rencana_askep + implementasi_askep).
// All options render as unchecked checkboxes from the selected diagnosis's
// master relations — the nurse checks what applies (no seed-then-delete).
@Component({
  components: { VCDateTimePicker, ImplementasiObatInline },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class AskepRanapInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly register!: string;
  @Prop() readonly rm!: string;
  @Prop({ default: () => [] }) readonly refDiag!: any[];
  @Prop({ default: 1 }) readonly nextSeq!: number;
  @Prop({ default: null }) readonly editItem!: any;
  @Prop({ default: null }) readonly salinItem!: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get isEdit(): boolean {
    return !!(this.editItem && this.editItem.id);
  }

  get isSalin(): boolean {
    return !this.isEdit && !!(this.salinItem && this.salinItem.id);
  }

  get sumberHidrasi(): any {
    return this.isEdit ? this.editItem : this.salinItem;
  }

  get judul(): string {
    if (this.isEdit) return "Edit Askep (mode 2)";
    if (this.isSalin) return "Salin Askep (mode 2)";
    return "Tambah Askep (mode 2)";
  }

  get labelSalinan(): string {
    if (!this.isSalin) return "-";

    const unit = this.salinItem.unit
      ? this.salinItem.unit.nama
      : this.salinItem.unit_id;
    const waktu = this.salinItem.authored_at
      ? moment(this.salinItem.authored_at, [
          "YYYY-MM-DD HH:mm:ss",
          moment.ISO_8601
        ]).format("DD-MM-YYYY HH:mm")
      : "-";

    return `${unit} · ${waktu}`;
  }

  diagnosis: any = null;
  etiologi: any[] = [];
  gejala: any[] = [];
  luaran: any[] = [];
  intervensi: any[] = [];
  implementasi: any[] = [];
  authoredAt: any = null;
  saving = false;
  extraDiagOption: any = null;

  // client-side v-for key generator for drug entries (keeps inline state stable)
  obatKeySeq = 0;

  get show() {
    return this.value;
  }
  set show(val) {
    this.$emit("input", val);
  }

  get diagnosisOptions() {
    const options = (this.refDiag || [])
      .slice()
      .sort((a, b) => String(a.id).localeCompare(String(b.id)))
      .map(item => ({ ...item, displayName: `${item.id} - ${item.name}` }));

    if (
      this.extraDiagOption &&
      !options.some(o => String(o.id) === String(this.extraDiagOption.id))
    ) {
      return [this.extraDiagOption].concat(options);
    }

    return options;
  }

  // implementasi options = items checked in the Intervensi section
  get implementasiCandidates() {
    const items = this.intervensi.reduce((a, i) => a.concat(i.item || []), []);
    const seen: any = {};
    return items.filter(it => {
      if (!it || it.id == null || seen[it.id]) return false;
      seen[it.id] = true;
      return true;
    });
  }

  onDiagnosisChange() {
    // ganti diagnosis = mulai ulang seluruh pilihan
    this.etiologi = [];
    this.gejala = [];
    this.luaran = [];
    this.intervensi = [];
    this.implementasi = [];
  }

  // ------------------------------------------------------------- etiologi/gejala
  isEtiologiSelected(id: any) {
    return this.etiologi.some(e => e.id === id);
  }
  toggleEtiologi(et: any, checked: boolean) {
    if (checked) {
      if (!this.isEtiologiSelected(et.id)) {
        this.etiologi.push({ id: et.id, name: et.name, text: null, option: null });
      }
    } else {
      const i = this.etiologi.findIndex(e => e.id === et.id);
      if (i > -1) this.etiologi.splice(i, 1);
    }
  }

  isGejalaSelected(id: any) {
    return this.gejala.some(g => g.id === id);
  }
  toggleGejala(gj: any, checked: boolean) {
    if (checked) {
      if (!this.isGejalaSelected(gj.id)) {
        this.gejala.push({ id: gj.id, name: gj.name, text: null, option: null });
      }
    } else {
      const i = this.gejala.findIndex(g => g.id === gj.id);
      if (i > -1) this.gejala.splice(i, 1);
    }
  }

  // ---------------------------------------------------------------------- luaran
  isLuaranSelected(id: any) {
    return this.luaran.some(l => l.id === id);
  }
  toggleLuaran(lua: any, checked: boolean) {
    if (checked) {
      if (!this.isLuaranSelected(lua.id)) {
        this.luaran.push({
          id: lua.id,
          name: lua.name,
          expectation: lua.expectation,
          category: lua.category,
          duration: "3",
          duration_unit: "hari",
          hasil: []
        });
      }
    } else {
      const i = this.luaran.findIndex(l => l.id === lua.id);
      if (i > -1) this.luaran.splice(i, 1);
    }
  }

  isLuaranHasilSelected(luaranId: any, hasilId: any) {
    const lua = this.luaran.find(l => l.id === luaranId);
    return lua ? lua.hasil.some(h => h.id === hasilId) : false;
  }
  toggleLuaranHasil(luaranId: any, itm: any, checked: boolean) {
    const lua = this.luaran.find(l => l.id === luaranId);
    if (!lua) return;
    if (checked) {
      if (!lua.hasil.some(h => h.id === itm.id)) {
        lua.hasil.push({ id: itm.id, name: itm.name });
      }
    } else {
      const i = lua.hasil.findIndex(h => h.id === itm.id);
      if (i > -1) lua.hasil.splice(i, 1);
    }
  }

  // ------------------------------------------------------------------ intervensi
  isIntervensiSelected(id: any) {
    return this.intervensi.some(i => i.id === id);
  }
  toggleIntervensi(int: any, checked: boolean) {
    if (checked) {
      if (!this.isIntervensiSelected(int.id)) {
        this.intervensi.push({ id: int.id, name: int.name, item: [] });
      }
    } else {
      const i = this.intervensi.findIndex(x => x.id === int.id);
      if (i > -1) this.intervensi.splice(i, 1);
      this.pruneImplementasi();
    }
  }

  isIntervensiItemSelected(intervensiId: any, itemId: any) {
    const int = this.intervensi.find(i => i.id === intervensiId);
    return int ? int.item.some(it => it.id === itemId) : false;
  }
  toggleIntervensiItem(intervensiId: any, itm: any, checked: boolean) {
    const int = this.intervensi.find(i => i.id === intervensiId);
    if (!int) return;
    if (checked) {
      if (!int.item.some(it => it.id === itm.id)) {
        int.item.push({
          id: itm.id,
          name: itm.name,
          implementasi: itm.implementasi,
          need_text: itm.need_text,
          options: itm.options || []
        });
      }
    } else {
      const i = int.item.findIndex(it => it.id === itm.id);
      if (i > -1) int.item.splice(i, 1);
      this.pruneImplementasi();
    }
  }

  // drop implementasi rows whose source item is no longer checked in Intervensi
  pruneImplementasi() {
    const candidates = this.implementasiCandidates;
    this.implementasi = this.implementasi.filter(row =>
      candidates.some(c => c.id === row.id)
    );
  }

  // ---------------------------------------------------------------- implementasi
  implIndex(id: any) {
    return this.implementasi.findIndex(r => r.id === id);
  }
  isImplementasiSelected(id: any) {
    return this.implIndex(id) > -1;
  }
  toggleImplementasi(itm: any, checked: boolean) {
    if (checked) {
      if (!this.isImplementasiSelected(itm.id)) {
        this.implementasi.push({
          id: itm.id,
          name: itm.name,
          implementasi: itm.implementasi,
          need_text: itm.need_text,
          options: itm.options || [],
          hasil: null,
          option_selected: null,
          text: null,
          hasilSuggestions: [],
          hasilLoading: false,
          hasilSearch: null,
          hasilSearchTimer: null
        });
      }
    } else {
      const i = this.implIndex(itm.id);
      if (i > -1) this.implementasi.splice(i, 1);
    }
  }

  // ------------------------------------------------- obat inline (mirror Askep 1)
  nextObatKey() {
    this.obatKeySeq += 1;
    return this.obatKeySeq;
  }
  toggleObatFlag(idx: number) {
    const item = this.implementasi[idx];
    if (!item) return;
    if (item.obat) {
      this.removeObatFlag(idx);
      return;
    }
    this.$set(this.implementasi, idx, { ...item, obat: [{ _k: this.nextObatKey() }] });
  }
  removeObatFlag(idx: number) {
    const item = this.implementasi[idx];
    if (!item) return;
    const next = { ...item };
    delete next.obat;
    this.$set(this.implementasi, idx, next);
  }
  addObatEntry(idx: number) {
    const item = this.implementasi[idx];
    if (!item) return;
    const obat = Array.isArray(item.obat) ? item.obat.slice() : [];
    obat.push({ _k: this.nextObatKey() });
    this.$set(this.implementasi, idx, { ...item, obat });
  }
  removeObatEntry(idx: number, di: number) {
    const item = this.implementasi[idx];
    if (!item || !Array.isArray(item.obat)) return;
    const obat = item.obat.slice();
    obat.splice(di, 1);
    if (obat.length === 0) {
      this.removeObatFlag(idx);
      return;
    }
    this.$set(this.implementasi, idx, { ...item, obat });
  }
  onObatInput(idx: number, di: number, obatPayload: any) {
    const item = this.implementasi[idx];
    if (!item || !Array.isArray(item.obat)) return;
    const obat = item.obat.slice();
    const prevK = obat[di] && obat[di]._k;
    obat[di] = { ...obatPayload, _k: prevK != null ? prevK : this.nextObatKey() };
    this.$set(this.implementasi, idx, { ...item, obat });
  }

  // ------------------------------------------------------------- hasil search
  onHasilSearchInput(idx: number, search: string) {
    const item = this.implementasi[idx];
    if (!item) return;
    item.hasilSearch = search;
    if (item.hasilSearchTimer) clearTimeout(item.hasilSearchTimer);
    if (!search || search.length < 3) {
      item.hasilSuggestions = [];
      return;
    }
    if (item.hasil === search) return;
    if (item.hasilSuggestions && item.hasilSuggestions.includes(search)) return;
    item.hasilSearchTimer = setTimeout(async () => {
      item.hasilLoading = true;
      try {
        const response = await ImplementasiAskepSvc.searchHasilImplementasi(search);
        item.hasilSuggestions = (response.data || []).map((r: any) => r.data);
      } catch (error) {
        item.hasilSuggestions = [];
      } finally {
        item.hasilLoading = false;
      }
    }, 300);
  }

  // ------------------------------------------------------------------- save
  get authoredAtStr() {
    return this.authoredAt
      ? moment(this.authoredAt).format("YYYY-MM-DD HH:mm:ss")
      : moment().format("YYYY-MM-DD HH:mm:ss");
  }

  buildDiag() {
    return {
      id: this.diagnosis.id,
      name: this.diagnosis.name,
      etiologi: this.etiologi.map(e => ({
        id: e.id,
        name: e.name,
        text: e.text || null,
        option: e.option || null
      })),
      gejala: this.gejala.map(g => ({
        id: g.id,
        name: g.name,
        text: g.text || null,
        option: g.option || null
      })),
      luaran: this.luaran.map(l => ({
        id: l.id,
        name: l.name,
        expectation: l.expectation,
        category: l.category,
        duration: l.duration,
        duration_unit: l.duration_unit,
        hasil: (l.hasil || []).map(h => ({ id: h.id, name: h.name }))
      })),
      intervensi: this.intervensi.map(i => ({
        id: i.id,
        name: i.name,
        item: (i.item || []).map(it => ({
          id: it.id,
          name: it.name,
          implementasi: it.implementasi,
          need_text: it.need_text,
          options: it.options || []
        }))
      }))
    };
  }

  buildImplContent() {
    return this.implementasi.map(itm => ({
      ...itm,
      options: undefined,
      need_text: undefined,
      name: undefined,
      hasilLoading: undefined,
      hasilSearch: undefined,
      hasilSearchTimer: undefined,
      hasilSuggestions: undefined
    }));
  }

  validateRencana(): string | null {
    if (!this.diagnosis || !this.diagnosis.id) return "Pilih diagnosis keperawatan.";
    if (this.gejala.length < 1) return "Centang minimal 1 Tanda/Gejala.";
    if (this.luaran.length < 1) return "Centang minimal 1 Luaran.";
    for (const l of this.luaran) {
      if (!l.duration) return `Isi durasi untuk luaran "${l.name}".`;
      if (!l.hasil || l.hasil.length < 1)
        return `Centang minimal 1 kriteria hasil untuk "${l.name}".`;
    }
    if (this.intervensi.length < 1) return "Centang minimal 1 Intervensi.";
    for (const i of this.intervensi) {
      if (!i.item || i.item.length < 1)
        return `Centang minimal 1 tindakan untuk intervensi "${i.name}".`;
    }
    return null;
  }

  validateImplementasi(): string | null {
    if (this.isEdit) return null;
    for (const it of this.implementasi) {
      if (!it.hasil) return `Isi hasil untuk implementasi "${it.name}".`;
    }
    return null;
  }

  async save() {
    if (this.readOnly) return;
    if (this.saving) return;

    const errR = this.validateRencana();
    if (errR) return appModule.sendErrorAlert(errR);
    const errI = this.validateImplementasi();
    if (errI) return appModule.sendErrorAlert(errI);

    if (this.isSalin) {
      const lanjut = confirm(
        "Perencanaan ini hasil salinan dari " +
          this.labelSalinan +
          ". Pastikan isinya sudah diperiksa dan sesuai kondisi pasien saat ini. Simpan?"
      );

      if (!lanjut) return;
    }

    this.saving = true;
    try {
      if (this.isEdit) {
        await RencanaAskepSvc.update(this.editItem.id, {
          pasien_rm: this.rm,
          register_id: parseInt(this.register),
          authored_at: this.authoredAtStr,
          content: [this.buildDiag()],
          mode: 2
        } as any);

        appModule.NoticeDelay("Berhasil Simpan Asuhan Keperawatan");
        this.$emit("saved");
        this.close();
        return;
      }

      await RencanaAskepSvc.create({
        pasien_rm: this.rm,
        register_id: parseInt(this.register),
        unit_id: userModule.scopedUnitId,
        authored_at: this.authoredAtStr,
        content: [this.buildDiag()],
        seq: this.nextSeq,
        mode: 2,
        salin_dari_id: this.isSalin ? this.salinItem.id : null
      } as any);

      // only proceed to implementasi once the plan is safely persisted
      if (this.implementasi.length > 0) {
        await ImplementasiAskepSvc.create({
          pasien_rm: this.rm,
          register_id: parseInt(this.register),
          unit_id: userModule.scopedUnitId,
          user_id: userModule.user.id,
          authored_at: this.authoredAtStr,
          content: this.buildImplContent()
        } as any);
      }

      appModule.NoticeDelay("Berhasil Simpan Asuhan Keperawatan");
      this.$emit("saved");
      this.close();
    } finally {
      this.saving = false;
    }
  }

  onAuthoredAtInput() {
    if (this.authoredAt && this.authoredAt > new Date()) {
      this.$nextTick(() => {
        this.authoredAt = null;
        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

  clearInput() {
    this.diagnosis = null;
    this.extraDiagOption = null;
    this.etiologi = [];
    this.gejala = [];
    this.luaran = [];
    this.intervensi = [];
    this.implementasi = [];
    this.authoredAt = null;
  }

  @Watch("show")
  changedShow(val: boolean) {
    if (!val) return;
    this.clearInput();
    if (this.isEdit || this.isSalin) this.hydrateFromEditItem();
  }

  hydrateFromEditItem() {
    const sumber = this.sumberHidrasi;
    const diag =
      sumber && Array.isArray(sumber.content) ? sumber.content[0] : null;
    if (!diag) return;

    const master = (this.refDiag || []).find(
      d => String(d.id) === String(diag.id)
    );
    if (master) {
      this.diagnosis = { ...master, displayName: `${master.id} - ${master.name}` };
    } else {
      this.extraDiagOption = { ...diag, displayName: `${diag.id} - ${diag.name}` };
      this.diagnosis = this.extraDiagOption;
    }

    this.etiologi = (diag.etiologi || []).map(e => ({ ...e }));
    this.gejala = (diag.gejala || []).map(g => ({ ...g }));
    this.luaran = (diag.luaran || []).map(l => ({
      ...l,
      hasil: (l.hasil || []).map(h => ({ ...h }))
    }));
    this.intervensi = (diag.intervensi || []).map(i => ({
      ...i,
      item: (i.item || []).map(it => ({ ...it }))
    }));

    this.authoredAt =
      !this.isSalin && sumber.authored_at
        ? moment(sumber.authored_at, [
            "YYYY-MM-DD HH:mm:ss",
            moment.ISO_8601
          ]).toDate()
        : null;
  }

  close() {
    this.show = false;
    this.clearInput();
  }
}
